import * as yup from 'yup'

import constants from 'constants/index'

const schema = (consentForm) => {
  const validationFields = {}

  const allowedTypes = constants.consent.SUPPORTED_DOCUMENT_FILE_INPUT_TYPES

  Object.entries(JSON.parse(consentForm?.components) || {}).forEach(
    ([key, value]) => {
      const isUserEmail =
        key === constants.consent.DEFAULT_EMAIL_ITEM_PROPS.name

      if (isUserEmail) {
        const emailValidation = yup
          .string()
          .email('Preencha um endereço de e-mail válido.')

        validationFields[key] = value?.required
          ? emailValidation.required('O e-mail é obrigatório.')
          : emailValidation
      } else if (value?.required) {
        validationFields[key] = yup.string().required()
      } else {
        validationFields[key] = yup.string()
      }
    },
  )

  validationFields['consentGivenDate'] = yup
    .date()
    .typeError('Precisa ser uma data válida')
    .max(new Date(), 'A data do consentimento não pode ser no futuro')
    .required('A data do consentimento é obrigatória')

  validationFields['document'] = yup.mixed().fileUpload({
    types: allowedTypes,
    mimeTypes: constants.consent.SUPPORTED_DOCUMENT_FILE_SCHEMA_TYPES,
    required: true,
  })

  return yup.object().shape(validationFields)
}

export default schema
